import ArticleInsertRec from '../vue_components/article-insert/article_insert_rec.js';
import ArticleInsertOutlink from '../vue_components/article-insert/article-insert-outlink.js'
import ArtInsertConfig from '../vue_components/article-insert/article_config.js';
import { getCardInfo } from '@/utils/request';

export default  {
    typeMap : {},
    getSpm: function(type) {
        let articleKey = 'r';
        let altasKey = 'i';
        let listKey = 'c';
        let signupkey = 'h';
        let contactKey = 't';
        let key = '';
        if(type == ArtInsertConfig.articleNoPic || type == ArtInsertConfig.articleOnePic) {
            key= articleKey;
        }else if (type == ArtInsertConfig.atlas) {
            key= altasKey;
        }else if(type ==ArtInsertConfig.list) {
            key = listKey;
        }else if(type == ArtInsertConfig.signup) {
            key = signupkey;
        }else if(type == ArtInsertConfig.contact) {
            key = contactKey;
        }
        this.typeMap[key] = this.typeMap[key] ? ++this.typeMap[key] : 1;
        return `${key}-${this.typeMap[key]}`
    },
    /**
     * @description 根据MP插件插入页面功能
     */
    articleInsert: function() {
        let $mpPlugin = $('.article-main mp-plugin');
        let shopInfoObj = [] //[{id:'',type:''.$el:''}]

        /**
         * @description 遍历插件
         */
        for (let i = 0; i < $mpPlugin.length; i++) {
            var $item = $mpPlugin[i];
            var type = $($item).attr('data-type');
            var item = {}
            try {
                let dataType = $mpPlugin[i].getAttribute('data-type');
                let dataContent = eval($mpPlugin[i].getAttribute('data-info'));
                if(ArtInsertConfig.shopCard.indexOf(+type) > -1 && dataContent && dataContent[0]) {
                    var key = dataContent[0].cardUuid;
                    item.id = key
                    item.type = type
                    item.$el = $item
                    shopInfoObj.push(item)
                    console.log(shopInfoObj)
                } else {
                    new ArticleInsertRec ({
                        el: $mpPlugin[i],
                        dataType: dataType,
                        data: dataContent[0],
                        templateSpm: this.getSpm(dataType)
                    }).init()
                }
            } catch(error) {
                console.log(error)
            }
        }
        //渲染商品卡
        this.renderShopCard(shopInfoObj)
    },
    /**
     * @description 渲染商品卡
     * @param {*} params
     */
    renderShopCard: function(params) {
        /**
         * @description 当存在功能卡的逻辑时
         */
        var ids = []
        if(params.length)params.forEach((item)=>ids.push(item.id))
        if(ids.length) {
            getCardInfo({ids:ids.join(",")}).then((res)=>{
                var resData = res.data;
                if(resData) {
                    resData.forEach(function(dataItem,index){
                        new ArticleInsertOutlink ({
                            el: params[index].$el,
                            dataType: params[index].type,
                            uuid: dataItem.uuid,
                            data: dataItem,
                        }).init()
                    })
                }
            })
        }
    }
}